<template lang="pug">
  sweet-modal(ref="modal" title="Пример готового письма")
    .email-preview-modal
      slot
</template>

<script>
export default {
  name: 'EmailPreviewModal',

  data() {
    return {};
  },

  methods: {
    open() {
      this.$refs.modal.open();
    }
  }
};
</script>

<style lang="scss">
.email-preview-modal {
  all: revert;
  * {
    all: revert;
  }
}
</style>
